var pos = {
    posName: null,
    tabPosName: null,
    fixNum:0,
    time: 1000,
    aniTime: 800,
    setPos: function () {
        var _this = this;
        $(function () {
            //获取定位参数
            var posName = _this.posName || getUrlPara('pos');
            var tabPosName = _this.tabPosName || getUrlPara('tabpos');

            if (!posName) {
                return;
            }

            // 不使用滚动条的记录
            if ('scrollRestoration' in history) {
                // 默认值为'auto'
                history.scrollRestoration = 'manual';
            }

            //获取定位坐标
            setTimeout(function () {
                clickTab();
            }, _this.time);

            function clickTab() {
                // var fixedPos = document.querySelector('.topbar').clientHeight * 2;

                if (tabPosName) {
                    var $tabpos = document.querySelector('.' + tabPosName);
                    if(!$tabpos){
                        return;
                    }
                    document.querySelector('.' + tabPosName).click();
                }

                if (posName) {
                    var $posClass = document.querySelector('.' + posName);
                    var $posId = document.querySelector('#' + posName);
                    var $pos = $posClass || $posId;
                    if(!$pos){
                        return;
                    }
                    // var posNum = $pos.offsetTop;
                    var rect = $pos.getBoundingClientRect();
                    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                    var posNum = rect.top + scrollTop;
                    var fix = _this.fixNum || _this.getFix();
                    posNum = posNum - fix;
                    $('html, body').animate({ scrollTop: posNum }, _this.aniTime)
                }
            }
        });
    },

    // 根据设备获取修正值
    getFix: function () {

        // 这里是pc
        if (window.cateData.device == 'pc') {
            var fix = 0
            if (window.cateData.pageModule === 'productList') { // 产品列表有个fix栏需要修正下
                fix = 230;
            }
            if(window.cateData.pageModule === 'productCategoryList') { //产品isg系列聚合页面
                fix = 235;
            }
            if(window.cateData.pageModule === '2020企业级') { //2020mb
                fix = 138;
            }
            if(window.cateData.pageModule === '2021暑期大放价') { //2021summer
                fix = 50;
            }
            if (window.cateData.pageModule === '2021商城双十一大促') { //2021双十一
                fix = 88;
            }
            if (window.cateData.pageModule === '2021-1212') { //2021双十二
                fix = 78;
            }
            if (window.cateData.pageModule === 'industry') { //行业
                fix = 110;
            }
            if (window.cateData.pageModule === '16G-INTEL') { //行业
                fix = 120;
            }
            if (window.cateData.pageModuleId === '2023618') { //行业
                fix = 125;
            }
            if (window.cateData.pageModule === 'business_pc') { //行业
                fix = 160;
            }
            if (window.cateData.pageModule === 'SB企业促销活动') { //2021双十一
                fix = -25;
            }
            if (window.cateData.pageModule === 'mb-club') { //数字化里程梦想积分计划
                fix = 70;
            }
            var navH = 0;
            // 顶部导航高度
            if ($('.navBox').length > 0) {
                navH = document.querySelector('.navBox').clientHeight;
            }
            // 产品中心 tab高度
            if ($('.product-category-box').length > 0) {
                var product_tab = $('.product-category-box');
                product_tab.addClass('classify-tab-list-fixed')
                navH = product_tab.height();
                // 用于计算tabCon的实际高度 计算后移除fixed类名
                product_tab.removeClass('classify-tab-list-fixed');
            }
            return navH + fix;
        }

        // 这里是wap
        if (window.cateData.device == 'wap') {
            if(window.cateData.pageModule === '2020企业级') { //2020mb
                var $navConH = $('.navigation-bar-container').height();
                return $navConH + 10;
            }
            if(window.cateData.pageModule === '2021暑期大放价') { //2020mb
                var $navConH = $('.hd-tab-box').height();
                return $navConH + 30;
            }
            if (window.cateData.pageModule === '2021商城双十一大促') { //2021双十一
                var $navConH = $('.hd-tab-box').height();
                return $navConH + 10;
            }
            if (window.cateData.pageModule === '2021-1212') { //2021双十二
                var $navConH = $('.hd-tab-box').height();
                return $navConH + 10;
            }
            if (window.cateData.pageModule === 'industry') { //行业
                var $navConH = $('.navigation-bar').height() + $('.topbar').height();
                return $navConH + 10;
            }
            if (window.cateData.pageModule === '15G-Server') { //行业
                var $navConH = $('.topbar').height();
                return $navConH;
            }
            if (location.href.indexOf('campaign/promotion') > -1) { //行业
                var $navConH = $('.fixed-tab-box').height();
                return $navConH;
            }
            if (window.cateData.pageModule === 'SB企业促销活动') { //2021双十一
                var $navConH = $('.fixed-tab-box').height();
                return $navConH - 10;
            }
            if (window.cateData.pageModule === 'mb-club') { //数字化里程梦想积分计划
                var $navConH = $('.header').height();
                return $navConH;
            }
            return document.querySelector('.topbar').clientHeight * 2; //这里乘2是因为wap端的商城向下滚动时会出现一个分类栏
        }

        return 0;

    },

    init: function (posName, tabPosName, fix, time, aniTime) {
        this.posName = posName;
        this.tabPosName = tabPosName;
        this.fixNum = fix || 0;
        this.time = time || 1000;
        this.aniTime = aniTime || 800;
        this.setPos();
    }
};

pos.init();
